import type { TFunction } from "@/i18n/catalog";

/**
 * `storage_types` is a four-row reference table seeded in
 * `20260330193222_inventory_schema.sql`: a stable `name` slug and an English `display_name`.
 *
 * Keyed on the slug — unlike `lib/food-labels.ts`, which has to key on the name because the waste
 * API sends no slug. Here the join carries `{ name, display_name }`, so the stable half is
 * available and is what this reads (POS2-1134).
 *
 * Literal keys in a lookup table, never a key assembled at runtime — `check-i18n.mjs` resolves
 * keys statically, so a built key is invisible to it.
 */
const STORAGE_TYPE_LABEL_KEYS: Record<string, string> = {
  chilled: "reference.storageType.chilled",
  frozen: "reference.storageType.frozen",
  ambient: "reference.storageType.ambient",
  non_food: "reference.storageType.non_food",
};

/**
 * The reader's wording for a storage type, falling back to the table's own `display_name`. A row
 * added to the table after this catalogue was written reads as the database spells it.
 */
export function storageTypeLabel(
  t: TFunction,
  storageType: { name: string; display_name: string } | null | undefined,
): string | undefined {
  if (!storageType) return undefined;
  const labelKey = STORAGE_TYPE_LABEL_KEYS[storageType.name];
  return labelKey ? t(labelKey) : storageType.display_name;
}
